const analytics = {
	formSend(name) {
		dataLayer.push({'event':'Callback', 'eventCategory': name, 'eventAction':'send'});
	},
	phoneClick() {
		dataLayer.push({'event':'Phone', 'eventCategory':'Phone', 'eventAction':'click'});
	},
	emailClick() {
		dataLayer.push({'event':'Email', 'eventCategory':'Email', 'eventAction':'click'});
	},
};

$('.header__phone a, .footer__phone__number a').on('click', () => {
	analytics.phoneClick();
});

$('.footer__phone__callback a[href^="mailto:"]').on('click', () => {
	analytics.emailClick();
});

export default analytics;